import { getStoreId } from "$/hooks/use-store-information"
import { userQueryOptions } from "$/lib/queries/user-queries"
import { WorkerRole } from "@repo/common"
import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

// Mirrors use-user-role.ts's isOwner logic (isAdmin, or an OWNER role on
// the current store) for use in a route loader/beforeLoad, where hooks
// aren't available.
export const requireOwner = async (queryClient: QueryClient) => {
  const [user, storeId] = await Promise.all([
    queryClient.ensureQueryData(userQueryOptions),
    getStoreId(),
  ])

  const isOwner =
    user?.isAdmin ||
    user?.roles.some(
      (role) => role.storeId === storeId && role.role === WorkerRole.OWNER,
    ) ||
    false

  if (!isOwner) {
    throw redirect({ to: "/", replace: true })
  }
}
